export default "__VITE_ASSET__31caf668__"